/**
 * PlanningGrid — renders a schedule/timetable grid.
 *
 * data: {
 *   headers: ["Lun", "Mar", "Mer"],
 *   rows: [
 *     { label: "9h", cells: ["Marie", "Luc", "?"] },
 *     { label: "14h", cells: ["Paul", "?", "Marie"] }
 *   ]
 * }
 *
 * "?" renders as a mystery cell.
 */

export default function PlanningGrid({ data }) {
    const headers = data?.headers;
    const rows = data?.rows;
    if (!Array.isArray(headers) || !Array.isArray(rows) || headers.length === 0) return null;

    return (
        <div className="qv-planning-wrap">
            <table className="qv-planning">
                <thead>
                    <tr>
                        <th className="qv-planning__corner" />
                        {headers.map((h, i) => (
                            <th key={i} className="qv-planning__header">{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, ri) => (
                        <tr key={ri}>
                            <td className="qv-planning__label">{row.label}</td>
                            {(row.cells || []).map((cell, ci) => {
                                const isMystery = cell === '?';
                                return (
                                    <td key={ci} className={`qv-planning__cell ${isMystery ? 'qv-planning__cell--mystery' : ''}`}>
                                        <span>{cell}</span>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
